import React, { useEffect, useState } from "react";
import ConfigurationPage from "templates/ConfigurationPage";
import Button from "rsuite/Button";
import AddLocation from "./AddLocation/AddLocation";
import Api from "util/Api";
import TableWithSearch from "components/TableWithSearch"
import { useToaster, Message, Table } from 'rsuite'
const { Column, HeaderCell, Cell } = Table;

const LocationsList = (props) => {
  const { auth, history } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [locationsList, setLocationsList] = useState([]);
  const [locationsListLoading, setLocationsListLoading] = useState(false);
  const toaster = useToaster();

  const getFacilities = async () => {
    await setLocationsListLoading(true)

    try {
      const data = await Api.withAuth(auth).getFacilities(auth.currentUser.defaultOrg);
      await setLocationsList(data);
    } catch (error) {
      toaster.push(
        <Message type="warning">
          <h6>Warning</h6>
          <p className='m-0'>Something went wrong while loading locations data.</p>
        </Message>,
        {
          placement: "topEnd"
        });
    }

    setLocationsListLoading(false);
  }

  useEffect(() => {
    getFacilities()
  }, [])

  const addLocation = () => {
    setModalOpen(true);
  };

  const addLocationBtn = () => (
    <Button onClick={addLocation} color="cyan" appearance="primary" size="lg">
      New Location
    </Button>
  );

  const goToViewLocationDetails = ({name}) => history.push(`/configuration/locations/${name}/`);

  return (
    <ConfigurationPage
      pageTitle="Locations"
      subnavRight={addLocationBtn()}
      className="locations"
      history={props.history}
    >
      <ConfigurationPage.Content>
        <TableWithSearch
          data={locationsList}
          dataLoading={locationsListLoading}
          setData={setLocationsList}
          onRowClick={goToViewLocationDetails}
          searchInputPlaceholder='Search locations'
        >

          <Column flexGrow={3} sortable>
            <HeaderCell><span className='header-cell'>Name</span></HeaderCell>
            <Cell dataKey="name" />
          </Column>

          <Column flexGrow={3}>
            <HeaderCell><span className='header-cell'>Sections / Neighborhoods</span></HeaderCell>
            <Cell dataKey="sections.sectionCount" />
          </Column>

          <Column flexGrow={3}>
            <HeaderCell><span className='header-cell'>Beds</span></HeaderCell>
            <Cell dataKey="beds" />
          </Column>

        </TableWithSearch>
        <AddLocation modalOpen={modalOpen} setModalOpen={setModalOpen} auth={auth} getFacilities={getFacilities} />
      </ConfigurationPage.Content>
    </ConfigurationPage>
  );
};

export default LocationsList;
